import { useMemo } from 'react';
import { graphql } from 'react-relay';
import { useQuery } from '@atlassian/jira-relay-apollo-migration-utils/src/services/use-query/index.tsx';
import type {
	getEpicsRelayCycleTimeReportQuery$variables,
	getEpicsRelayCycleTimeReportQuery$data,
} from '@atlassian/jira-relay/src/__generated__/getEpicsRelayCycleTimeReportQuery.graphql';
import type { ServiceQueryResult } from '@atlassian/jira-software-deployments-service-query-types/src/services/types.tsx';
import type { Epic } from '../../common/types.tsx';
import { useProjectAri, transformQueryResult } from './utils.tsx';

export const useEpics = (text: string): ServiceQueryResult<Epic[]> => {
	const projectAri = useProjectAri();
	const variables = {
		first: 10,
		filter: {
			projectId: projectAri ?? '',
			text,
		},
	};

	const queryResult = useQuery<
		getEpicsRelayCycleTimeReportQuery$variables,
		getEpicsRelayCycleTimeReportQuery$data
	>(
		// disabling eslint rule since transformation is happaning inside transformQueryResult()
		/* eslint-disable @atlassian/relay/unused-fields */
		graphql`
			query getEpicsRelayCycleTimeReportQuery($first: Int!, $filter: JiraReleasesEpicFilter!) {
				jiraReleases @required(action: THROW) {
					epics(first: $first, filter: $filter) @required(action: THROW) {
						nodes @required(action: THROW) {
							id @required(action: THROW)
							summary @required(action: THROW)
						}
					}
				}
			}
		`,
		/* eslint-enable @atlassian/relay/unused-fields */
		{
			variables,
			skip: projectAri === null,
		},
	);

	return useMemo(() => transformQueryResult(queryResult), [queryResult]);
};
